import { Radio } from '@spotnana/blocks/src/Radio';
import { Typography } from '@spotnana/blocks/src/Typography';
import { margins } from '@spotnana/blocks/src/utils';
import { BookingPaymentSource, PaymentSourceType } from 'obt-common';
import { getPaymentSourceRewardsProgramInfo } from 'obt-common/utils/payment/getPaymentSourceRewardsProgramInfo';
import { useTranslation } from 'react-i18next';

interface RewardsProgramOptionProps {
  paymentSource?: BookingPaymentSource;
  onPaymentSourceTypeSelect: (paymentSourceType: PaymentSourceType) => void;
  selectedPaymentSourceId: string;
}

const RewardsProgramOption = ({
  paymentSource,
  onPaymentSourceTypeSelect,
  selectedPaymentSourceId,
}: RewardsProgramOptionProps) => {
  const { t: tt } = useTranslation('WEB');
  const { id, isUsable, points } = getPaymentSourceRewardsProgramInfo(paymentSource);

  if (!paymentSource) {
    return null;
  }

  return (
    <div>
      <Radio
        label={tt('Pay with your reward points ({{points}} points available)', {
          points: points.toLocaleString(),
        })}
        value={PaymentSourceType.RewardsProgram}
        checked={selectedPaymentSourceId === id}
        onChange={() => {
          onPaymentSourceTypeSelect(PaymentSourceType.RewardsProgram);
        }}
        name="paymentMethod"
        disabled={!isUsable}
      />
      {!isUsable && (
        <Typography kind="medium" variant="body2" color="secondary" css={margins.yt.m1point5}>
          {tt('You cannot pay for this booking through this method! Minimum required balance is insufficient.')}
        </Typography>
      )}
    </div>
  );
};

export default RewardsProgramOption;
